// @flow

import {
  brazeChangeUser,
  brazeInitialize,
  brazeRemoveSubscription,
  brazeContentCardsRefresh,
  isBrazeInitialized,
  checkDevice
} from "@tvg/braze";
import { androidSubscribeToContentCards } from "@tvg/braze/src/androidBrazeBridge";
import { get, isEqual } from "lodash";
import Poller from "@tvg/poller";
import type { UnaryFn } from "@tvg/types/Functional";
import type { Props } from "@tvg/types/Login";
import { setBrazeContentCards } from "@tvg/braze/src/actions";
import type { Dispatch } from "redux";
import type { SetBrazeContentCardsAction } from "@tvg/braze/src/actions";

const BrazePoller = new Poller();

const startContentCardsPoller = (brazerTimer: number) => {
  BrazePoller.start(() => {
    if (isBrazeInitialized()) {
      brazeContentCardsRefresh();
    }
  }, brazerTimer * 1000);
};

const initializeBraze = (
  prevProps: Props,
  nextProps: Props,
  subscription: ?string,
  setState: UnaryFn<mixed, void>,
  dispatch: Dispatch<SetBrazeContentCardsAction>
) => {
  if (typeof window !== "undefined") {
    if (
      ((!prevProps.user.isLogged || !prevProps.user.accountNumber) &&
        nextProps.user.isLogged &&
        !!nextProps.user.accountNumber) ||
      (prevProps.user.isLogged &&
        !!prevProps.user.accountNumber &&
        !subscription)
    ) {
      brazeInitialize(); // needed case never logged in before (!userLoginOnce)
      brazeChangeUser(nextProps.user);
      brazeContentCardsRefresh();

      if (checkDevice() && subscription) {
        brazeRemoveSubscription(subscription);
      }
      if (checkDevice()) {
        if (window.appboy) {
          const subscriptionID = window.appboy.subscribeToContentCardsUpdates(
            (cards) => {
              dispatch(
                setBrazeContentCards({
                  unviewed: cards.getUnviewedCardCount(),
                  totalCards: get(cards, "cards.length", 0),
                  cards: get(cards, "cards", 0)
                })
              );
            }
          );
          setState(() => ({ subscription: subscriptionID }));
        }
      } else {
        androidSubscribeToContentCards();
        setState(() => ({ subscription: "subscription" }));
      }
      startContentCardsPoller(nextProps.brazePoller);
    } else if (
      window.localStorage.getItem("userLoginOnce") &&
      !isBrazeInitialized()
    ) {
      brazeInitialize();
    }

    if (
      !prevProps.contentCardsOpen &&
      nextProps.contentCardsOpen &&
      BrazePoller.isRunning()
    ) {
      BrazePoller.stop();
    }

    if (
      prevProps.contentCardsOpen &&
      !nextProps.contentCardsOpen &&
      isBrazeInitialized() &&
      !BrazePoller.isRunning()
    ) {
      startContentCardsPoller(nextProps.brazePoller);
    }

    if (
      (!isEqual(nextProps.user.isLogged, prevProps.user.isLogged) ||
        !isEqual(nextProps.user.accountNumber, prevProps.user.accountNumber) ||
        !isEqual(nextProps.brazePoller, prevProps.brazePoller)) &&
      BrazePoller.isRunning()
    ) {
      BrazePoller.stop();
      startContentCardsPoller(nextProps.brazePoller);
    }
  }
};

export default initializeBraze;
